/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para la cabecera/información general de un partido. Contiene el partido y los objetos de equipo completos.
 */
export interface MatchInfoDTO { 
    match_id: number;
    match_date: string;
    video_id: string;
    video_title: string;
    season_name: string;
    competition_name: string;
    category_name: string;
    match_day?: number | null;
    home_score: number;
    away_score: number;
    home_team_id: string;
    home_team_name: string;
    home_team_stadium?: string | null;
    home_team_location?: string | null;
    away_team_id: string;
    away_team_name: string;
    away_team_stadium?: string | null;
    away_team_location?: string | null;
}

